export default {
	Peru: 1,
	Ecuador: 2,
};



// WEBPACK FOOTER //
// ./src/shared/countries.js